import { useEffect } from "react";
import { setIsFetchingData } from "@features/builder/builderSlice";
import { useAppDispatch } from "@app/hooks";
import type { ErrorType } from "@typedefs/interfaces";
import useErrorMessage from "@utils/useErrorMessage";

const useModuleHook = ({
	skeletonsLoadingDeps,
	isMutateError,
	mutateError,
}: {
	skeletonsLoadingDeps: boolean[];
	isMutateError: boolean;
	mutateError: ErrorType | null;
}) => {
	const dispatch = useAppDispatch();
	//update isFetching for skeletons
	useEffect(() => {
		dispatch(setIsFetchingData(skeletonsLoadingDeps.some((isLoading) => isLoading)),);
		return () => {
			dispatch(setIsFetchingData(false));
		};
	}, [...skeletonsLoadingDeps, dispatch]); //eslint-disable-line

	const { errorMsg } = useErrorMessage({
		error: mutateError,
		isError: isMutateError,
	});

	return { errorMsg };
};

export default useModuleHook;
